import * as ActionTypes from 'state/actions/types'

export const sentimentsChangeField = (field, value) => {
  return {
    type: ActionTypes.SENTIMENTS_CHANGE_FIELD,
    field,
    value
  }
}

export const sentimentsChangeDateRange = (startDate, endDate) => {
  return {
    type: ActionTypes.SENTIMENTS_CHANGE_CUSTOM_DATE_RANGE,
    startDate,
    endDate
  }
}

export const sentimentsMoveCustomDateRange = operation => {
  return {
    type: ActionTypes.SENTIMENTS_MOVE_CUSTOM_DATE_RANGE,
    operation
  }
}
